import {
    SearchComponent,
    SearchComponentEnum,
} from "@utils/search/@types/searchComponent";
import { SearchComponentConfigurationMap } from "@utils/search/@types/searchConfiguration";

import { DefaultHitsPerPage } from "@components/Search/SearchResults/StateComponents/HitsPerPage/hitsPerPage.config";
import { ProductSortBy } from "@components/Search/SearchResults/StateComponents/Sort/sort.config";

const defaultConfiguration: SearchComponentConfigurationMap = {
    [SearchComponent.PRODUCT_RESULT_LIST]: {
        component: SearchComponent.PRODUCT_RESULT_LIST,
    },
    [SearchComponent.PRODUCT_HITS_PER_PAGE]: {
        component: SearchComponent.PRODUCT_HITS_PER_PAGE,
        hitsPerPage: DefaultHitsPerPage,
    },
    [SearchComponent.PRODUCT_PAGINATION]: {
        component: SearchComponent.PRODUCT_PAGINATION,
        hitsWithInjected: 0,
        hitsWithoutInjected: 0,
    },
    [SearchComponent.PRODUCT_NUMBER_OF_HITS]: {
        component: SearchComponent.PRODUCT_NUMBER_OF_HITS,
    },
    [SearchComponent.PRODUCT_FACETS]: {
        component: SearchComponent.PRODUCT_FACETS,
        facetFilters: [],
        numericFilters: [],
    },
    [SearchComponent.PRODUCT_SORT]: {
        component: SearchComponent.PRODUCT_SORT,
        sortBy: ProductSortBy.DEFAULT,
    },
    [SearchComponent.CONTENT_RESULT_LIST]: {
        component: SearchComponent.CONTENT_RESULT_LIST,
    },
    [SearchComponent.CONTENT_NUMBER_OF_HITS]: {
        component: SearchComponent.CONTENT_NUMBER_OF_HITS,
    },
    [SearchComponent.CONTENT_PAGINATION]: {
        component: SearchComponent.CONTENT_PAGINATION,
        hitsWithInjected: 0,
        hitsWithoutInjected: 0,
    },
    [SearchComponent.CONTENT_HITS_PER_PAGE]: {
        component: SearchComponent.CONTENT_HITS_PER_PAGE,
        hitsPerPage: DefaultHitsPerPage,
    },
};

const getDefaultConfiguration = () => structuredClone(defaultConfiguration);

const getDefaultComponentConfiguration = (component: SearchComponentEnum) =>
    structuredClone(defaultConfiguration[component]);

const getDefaultConfigurationValues = () => Object.values(defaultConfiguration);

export {
    getDefaultComponentConfiguration, getDefaultConfiguration, getDefaultConfigurationValues
};

